import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { getGatewayUrl } from '@config/util';

export const bpnRedirectionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  window.location.href = `${getGatewayUrl()}/bpn${state.url}`;
  return false;
};
